import React from "react";

const FiltresVehicule = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    let newFilters = { ...filters };

    if (type === "checkbox") {
      newFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      newFilters[name] = value;
    }

    onChange(newFilters);
  };

  const uniqueTypes = [...new Set(annonces.map((a) => a.typeVehicule).filter(Boolean))];
  const uniqueCarburants = [...new Set(annonces.map((a) => a.carburant).filter(Boolean))];

  return (
    <div>
      <h3>Type de véhicule</h3>
      {uniqueTypes.map((type) => (
        <label key={type}>
          <input type="checkbox" name="type" value={type} onChange={handleChange} />
          {type}
        </label>
      ))}

      <h3>Carburant</h3>
      {uniqueCarburants.map((c) => (
        <label key={c}>
          <input type="checkbox" name="carburant" value={c} onChange={handleChange} />
          {c}
        </label>
      ))}

      <h3>Chevaux</h3>
      <input name="chevauxMin" type="number" placeholder="Min" onChange={handleChange} />
      <input name="chevauxMax" type="number" placeholder="Max" onChange={handleChange} />

      <h3>Kilométrage</h3>
      <input name="kilometrageMin" type="number" placeholder="Min" onChange={handleChange} />
      <input name="kilometrageMax" type="number" placeholder="Max" onChange={handleChange} />

      <h3>Année modèle</h3>
      <input name="anneeModeleMin" type="number" placeholder="Min" onChange={handleChange} />
      <input name="anneeModeleMax" type="number" placeholder="Max" onChange={handleChange} />

      <h3>Prix</h3>
      <input name="prixMin" type="number" placeholder="Min" onChange={handleChange} />
      <input name="prixMax" type="number" placeholder="Max" onChange={handleChange} />
    </div>
  );
};

export default FiltresVehicule;
